import { Injectable } from '@angular/core';
import { HttpRestService } from '@core/services/http-rest.service';
import { OrgApplicant } from '@core/typings/applicant.typing';
import { ApplicationByFormFromApi, EligibilityResponse, MyApplicationsApi, SaveApplication, SaveApplicationResponse, SubmitEligibility } from '@core/typings/application.typing';
import { ClientBrandingFromApi } from '@core/typings/branding.typing';
import { CancelApplicationPayload } from '@core/typings/ui/cancel-application.typing';
import { ProgramAutomationForApplicantApi } from '@features/programs/program-automation/program-automation.typing';

@Injectable({ providedIn: 'root' })
export class ApplicationApplicantResources {

  constructor (
    private httpRestService: HttpRestService
  ) { }

  getApplicationByForm (
    applicationId: number,
    formId: number
  ): Promise<ApplicationByFormFromApi> {
    const endpoint = 'api/portal/applications/' + applicationId +
      '/forms/' + formId;

    return this.httpRestService.get(endpoint);
  }

  getApplications (
    page: number,
    pageSize: number,
    includeDraft = false
  ): Promise<MyApplicationsApi> {
    const endpoint = 'api/portal/applications?page=' + page +
      '&pageSize=' + pageSize + '&includeDraft=' + includeDraft;

    return this.httpRestService.get(endpoint);
  }

  deleteApplication (id: number) {
    const endpoint = `api/portal/applications/${id}`;

    return this.httpRestService.delete(endpoint);
  }

  saveApplication (data: SaveApplication): Promise<SaveApplicationResponse> {
    return this.httpRestService.post('api/portal/applications', data);
  }

  submitEligibility (data: SubmitEligibility): Promise<EligibilityResponse> {
    const endpoint = 'api/portal/applicant/PreApplicationFormResponse';

    return this.httpRestService.post(endpoint, data);
  }

  cancelApplication (
    payload: CancelApplicationPayload
  ) {
    return this.httpRestService.post('api/portal/applications/CancelApplication', payload);
  }

  getClientBranding (clientId: number): Promise<ClientBrandingFromApi> {
    const endpoint = 'api/portal/programs/branding?clientId=' + clientId;

    return this.httpRestService.get(endpoint);
  }

  getRoutingInfoForApplicant (
    landingLinkGuid: string
  ): Promise<ProgramAutomationForApplicantApi> {
    const endpoint = 'api/portal/programs/GetProgramRouting';

    return this.httpRestService.post(endpoint, {
      landingLinkGuid
    });
  }

  getApplicantsForOrg (
    orgId: number
  ): Promise<OrgApplicant[]> {
    const endpoint = `api/manager/applications/GetApplicantsForOrg/${orgId}`;

    return this.httpRestService.get(endpoint);
  }
}
